module.exports = __webpack_public_path__ + "img/2.1318c0b1.jpg";